import { STRAPI_URL } from "../env";

/**
 * Backs the create-item typeahead: checks whether a BasicItem with the given
 * customId (Archer ID) already exists, so the create dialog can flag a
 * duplicate before the user submits.
 */
export async function fetchBasicItemExistsByCustomId(
  customId: string
): Promise<boolean> {
  const trimmed = customId.trim();
  if (!trimmed) return false;

  try {
    const response = await fetch(
      `${STRAPI_URL}/basic-item/exists-by-custom-id?customId=${encodeURIComponent(
        trimmed
      )}`,
      { credentials: "include" }
    );

    if (!response.ok) {
      throw new Error(
        `exists-by-custom-id failed with status ${response.status}.`
      );
    }
    const result = (await response.json()) as { exists: boolean };
    return result.exists;
  } catch {
    // A failed check should never block typing; the server still enforces
    // uniqueness as a defense-in-depth check on submit.
    return false;
  }
}
